module.exports = __webpack_public_path__ + "static/img/preview-04.528e49e1.webp";